/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '../types';

import type { FetchOptions } from "../fetcher/fetcher.types"
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, useMutation, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher/index';
export type AuthResponseFieldsFragment = { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null };

export type LoginResponseFieldsFragment = { __typename?: 'LoginResponse', token?: string | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null };

export type RegisterResponseFieldsFragment = { __typename?: 'RegisterResponse', token?: string | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null };

export type UserFieldsFragment = { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null };

export type UserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, currency?: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null } | null };

export type UserLocationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserLocationQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, isTemporary: boolean, location: { __typename?: 'UserLocation', country: Types.CountryCode } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type UserBlockslistedQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserBlockslistedQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', isUserBlocklisted: { __typename?: 'IsUserBlocklisted', extensionPopup: boolean } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type UserCheckEarlyTrialCancelQueryVariables = Types.Exact<{
  stripeCustomerId: Types.Scalars['String']['input'];
}>;


export type UserCheckEarlyTrialCancelQuery = { __typename?: 'Query', userCheckEarlyTrialCancel?: { __typename?: 'UserCheckEarlyTrialCancelResponse', earlyTrialCancel: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } | null };

export type UserEligibleToAutostartFreeTrialQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserEligibleToAutostartFreeTrialQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', stripeCustomerId: string, id: string, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isEligibleForAutoStartTrial: boolean }, studioAi: { __typename?: 'SubscriptionAccessDetails', isEligibleForAutoStartTrial: boolean } }, stripeCustomer?: { __typename?: 'StripeCustomer', account: Types.StripeAccount, id: string } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type UserShippingAddressQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserShippingAddressQuery = { __typename?: 'Query', usersShippingAddress: { __typename?: 'UserShippingAddressResponse', message?: string | null, address?: { __typename?: 'UsersShippingAddress', name: string, address1: string, address2: string, city: string, state: string, postCode: string, country: string } | null } };

export type UserProjectDetailsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserProjectDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type LogInMutationVariables = Types.Exact<{
  input: Types.LoginInput;
}>;


export type LogInMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginResponse', token?: string | null, challenge?: { __typename?: 'AuthChallenge', type: Types.ChallengeType, otp?: string | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null } | null };

export type RegisterMutationVariables = Types.Exact<{
  input: Types.RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: { __typename?: 'RegisterResponse', token?: string | null, challenge?: { __typename?: 'AuthChallenge', type: Types.ChallengeType, otp?: string | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null } | null };

export type LostPasswordMutationVariables = Types.Exact<{
  input: Types.LostPasswordInput;
}>;


export type LostPasswordMutation = { __typename?: 'Mutation', lostPassword?: { __typename?: 'LostPasswordResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type ReportJwtAuthOutcomeMutationVariables = Types.Exact<{
  input: Types.JwtAuthOutcomeInput;
}>;


export type ReportJwtAuthOutcomeMutation = { __typename?: 'Mutation', reportJwtAuthOutcome?: { __typename?: 'JwtAuthOutcomeResponse', accepted: boolean } | null };

export type UserAuthQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserAuthQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, isTemporary: boolean } | null } | null };

export type UserSubscriptionsGraphicsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserSubscriptionsGraphicsQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', subscriptions?: { __typename?: 'Subscriptions', graphics?: boolean | null } | null } | null } | null };

export type UserAllSubscriptionsTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserAllSubscriptionsTypesQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', subscriptions?: { __typename?: 'Subscriptions', fonts?: boolean | null, crafts?: boolean | null, graphics?: boolean | null, embroidery?: boolean | null, classes?: boolean | null } | null } | null } | null };

export type UserCurrencyCodeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserCurrencyCodeQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null } } | null, currency?: { __typename?: 'Currency', code?: Types.CurrencyCode | null } | null } | null };

export type UsersUpdateFlagsMutationVariables = Types.Exact<{
  input: Types.UserUpdateFlagsInput;
}>;


export type UsersUpdateFlagsMutation = { __typename?: 'Mutation', usersUpdateFlags: { __typename?: 'UpdateUserResponse', success?: boolean | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type PublicUserProfileQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type PublicUserProfileQuery = { __typename?: 'Query', publicUserProfile: { __typename?: 'PublicUserProfile', id: string, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, slug?: string | null, displayName?: string | null, shopName?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } } };

export type UserFollowersCountQueryVariables = Types.Exact<{
  input: Types.UserFollowersCountInput;
}>;


export type UserFollowersCountQuery = { __typename?: 'Query', userFollowersCount?: { __typename?: 'UserFollowersCountResponse', FollowersCount: number, FollowingCount: number, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type DeleteUserAccountMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteUserAccountMutation = { __typename?: 'Mutation', deleteUserAccount: { __typename?: 'DeleteUserAccountResponse', deleted: boolean, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type LogoutMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutResponse', logout?: { __typename?: 'StatusMessage', success: boolean, message: string } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };


export const UserFieldsFragmentDoc = /*#__PURE__*/ `
    fragment UserFields on User {
  id
  avatarUrl
  language
  email
  slug
  firstName
  lastName
  stripeCustomerId
  stripeCustomer {
    id
    account
  }
  roles
  currency {
    code
    symbol
  }
  subscriptionAccess {
    allAccess {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    studioAi {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    coins {
      isSubscribed
      subscription {
        id
        type
      }
    }
  }
  flags {
    isNew
    isGAdsSignup
    identifyUser
  }
  affiliateInfo {
    affiliateId
  }
  isTemporary
  isBanned
  bio
}
    `;
export const AuthResponseFieldsFragmentDoc = /*#__PURE__*/ `
    fragment AuthResponseFields on AuthResponse {
  token
  user {
    ...UserFields
  }
}
    `;
export const LoginResponseFieldsFragmentDoc = /*#__PURE__*/ `
    fragment LoginResponseFields on LoginResponse {
  token
  user {
    ...UserFields
  }
}
    `;
export const RegisterResponseFieldsFragmentDoc = /*#__PURE__*/ `
    fragment RegisterResponseFields on RegisterResponse {
  token
  user {
    ...UserFields
  }
}
    `;
export const UserDocument = /*#__PURE__*/ `
    query user {
  me {
    ...AuthResponseFields
    currency {
      code
      symbol
    }
    errors {
      code
      message
    }
  }
}
    ${AuthResponseFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

export const useUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      variables?: UserQueryVariables,
      options?: Omit<UseQueryOptions<UserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['user'] : ['user', variables],
    queryFn: fetcher<UserQuery, UserQueryVariables>(UserDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserQuery.document = UserDocument;

useUserQuery.getKey = (variables?: UserQueryVariables) => variables === undefined ? ['user'] : ['user', variables];

useUserQuery.rootKey = 'user';

export const useSuspenseUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      variables?: UserQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userSuspense'] : ['userSuspense', variables],
    queryFn: fetcher<UserQuery, UserQueryVariables>(UserDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserQuery.document = UserDocument;

useSuspenseUserQuery.getKey = (variables?: UserQueryVariables) => variables === undefined ? ['userSuspense'] : ['userSuspense', variables];

useSuspenseUserQuery.rootKey = 'user';

export const useInfiniteUserQuery = <
      TData = InfiniteData<UserQuery>,
      TError = unknown
    >(
      variables: UserQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['user.infinite'] : ['user.infinite', variables],
      queryFn: (metaData) => fetcher<UserQuery, UserQueryVariables>(UserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserQuery.getKey = (variables?: UserQueryVariables) => variables === undefined ? ['user.infinite'] : ['user.infinite', variables];

useInfiniteUserQuery.rootKey = 'user.infinite';

export const useSuspenseInfiniteUserQuery = <
      TData = InfiniteData<UserQuery>,
      TError = unknown
    >(
      variables: UserQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['user.infiniteSuspense'] : ['user.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserQuery, UserQueryVariables>(UserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserQuery.getKey = (variables?: UserQueryVariables) => variables === undefined ? ['user.infiniteSuspense'] : ['user.infiniteSuspense', variables];

useSuspenseInfiniteUserQuery.rootKey = 'user.infinite';


useUserQuery.fetcher = (variables?: UserQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserQuery, UserQueryVariables>(UserDocument, variables, options, fetchOptions);

export const UserLocationDocument = /*#__PURE__*/ `
    query userLocation {
  me {
    token
    user {
      id
      isTemporary
      location {
        country
      }
    }
    errors {
      code
      message
    }
  }
}
    `;

export const useUserLocationQuery = <
      TData = UserLocationQuery,
      TError = unknown
    >(
      variables?: UserLocationQueryVariables,
      options?: Omit<UseQueryOptions<UserLocationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserLocationQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserLocationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userLocation'] : ['userLocation', variables],
    queryFn: fetcher<UserLocationQuery, UserLocationQueryVariables>(UserLocationDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserLocationQuery.document = UserLocationDocument;

useUserLocationQuery.getKey = (variables?: UserLocationQueryVariables) => variables === undefined ? ['userLocation'] : ['userLocation', variables];

useUserLocationQuery.rootKey = 'userLocation';

export const useSuspenseUserLocationQuery = <
      TData = UserLocationQuery,
      TError = unknown
    >(
      variables?: UserLocationQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserLocationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserLocationQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserLocationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userLocationSuspense'] : ['userLocationSuspense', variables],
    queryFn: fetcher<UserLocationQuery, UserLocationQueryVariables>(UserLocationDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserLocationQuery.document = UserLocationDocument;

useSuspenseUserLocationQuery.getKey = (variables?: UserLocationQueryVariables) => variables === undefined ? ['userLocationSuspense'] : ['userLocationSuspense', variables];

useSuspenseUserLocationQuery.rootKey = 'userLocation';

export const useInfiniteUserLocationQuery = <
      TData = InfiniteData<UserLocationQuery>,
      TError = unknown
    >(
      variables: UserLocationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserLocationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserLocationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserLocationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userLocation.infinite'] : ['userLocation.infinite', variables],
      queryFn: (metaData) => fetcher<UserLocationQuery, UserLocationQueryVariables>(UserLocationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserLocationQuery.getKey = (variables?: UserLocationQueryVariables) => variables === undefined ? ['userLocation.infinite'] : ['userLocation.infinite', variables];

useInfiniteUserLocationQuery.rootKey = 'userLocation.infinite';

export const useSuspenseInfiniteUserLocationQuery = <
      TData = InfiniteData<UserLocationQuery>,
      TError = unknown
    >(
      variables: UserLocationQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserLocationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserLocationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserLocationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userLocation.infiniteSuspense'] : ['userLocation.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserLocationQuery, UserLocationQueryVariables>(UserLocationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserLocationQuery.getKey = (variables?: UserLocationQueryVariables) => variables === undefined ? ['userLocation.infiniteSuspense'] : ['userLocation.infiniteSuspense', variables];

useSuspenseInfiniteUserLocationQuery.rootKey = 'userLocation.infinite';


useUserLocationQuery.fetcher = (variables?: UserLocationQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserLocationQuery, UserLocationQueryVariables>(UserLocationDocument, variables, options, fetchOptions);

export const UserBlockslistedDocument = /*#__PURE__*/ `
    query userBlockslisted {
  me {
    user {
      isUserBlocklisted {
        extensionPopup
      }
    }
    errors {
      code
      message
    }
  }
}
    `;

export const useUserBlockslistedQuery = <
      TData = UserBlockslistedQuery,
      TError = unknown
    >(
      variables?: UserBlockslistedQueryVariables,
      options?: Omit<UseQueryOptions<UserBlockslistedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserBlockslistedQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserBlockslistedQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userBlockslisted'] : ['userBlockslisted', variables],
    queryFn: fetcher<UserBlockslistedQuery, UserBlockslistedQueryVariables>(UserBlockslistedDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserBlockslistedQuery.document = UserBlockslistedDocument;

useUserBlockslistedQuery.getKey = (variables?: UserBlockslistedQueryVariables) => variables === undefined ? ['userBlockslisted'] : ['userBlockslisted', variables];

useUserBlockslistedQuery.rootKey = 'userBlockslisted';

export const useSuspenseUserBlockslistedQuery = <
      TData = UserBlockslistedQuery,
      TError = unknown
    >(
      variables?: UserBlockslistedQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserBlockslistedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserBlockslistedQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserBlockslistedQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userBlockslistedSuspense'] : ['userBlockslistedSuspense', variables],
    queryFn: fetcher<UserBlockslistedQuery, UserBlockslistedQueryVariables>(UserBlockslistedDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserBlockslistedQuery.document = UserBlockslistedDocument;

useSuspenseUserBlockslistedQuery.getKey = (variables?: UserBlockslistedQueryVariables) => variables === undefined ? ['userBlockslistedSuspense'] : ['userBlockslistedSuspense', variables];

useSuspenseUserBlockslistedQuery.rootKey = 'userBlockslisted';

export const useInfiniteUserBlockslistedQuery = <
      TData = InfiniteData<UserBlockslistedQuery>,
      TError = unknown
    >(
      variables: UserBlockslistedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserBlockslistedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserBlockslistedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserBlockslistedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userBlockslisted.infinite'] : ['userBlockslisted.infinite', variables],
      queryFn: (metaData) => fetcher<UserBlockslistedQuery, UserBlockslistedQueryVariables>(UserBlockslistedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserBlockslistedQuery.getKey = (variables?: UserBlockslistedQueryVariables) => variables === undefined ? ['userBlockslisted.infinite'] : ['userBlockslisted.infinite', variables];

useInfiniteUserBlockslistedQuery.rootKey = 'userBlockslisted.infinite';

export const useSuspenseInfiniteUserBlockslistedQuery = <
      TData = InfiniteData<UserBlockslistedQuery>,
      TError = unknown
    >(
      variables: UserBlockslistedQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserBlockslistedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserBlockslistedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserBlockslistedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userBlockslisted.infiniteSuspense'] : ['userBlockslisted.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserBlockslistedQuery, UserBlockslistedQueryVariables>(UserBlockslistedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserBlockslistedQuery.getKey = (variables?: UserBlockslistedQueryVariables) => variables === undefined ? ['userBlockslisted.infiniteSuspense'] : ['userBlockslisted.infiniteSuspense', variables];

useSuspenseInfiniteUserBlockslistedQuery.rootKey = 'userBlockslisted.infinite';


useUserBlockslistedQuery.fetcher = (variables?: UserBlockslistedQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserBlockslistedQuery, UserBlockslistedQueryVariables>(UserBlockslistedDocument, variables, options, fetchOptions);

export const UserCheckEarlyTrialCancelDocument = /*#__PURE__*/ `
    query userCheckEarlyTrialCancel($stripeCustomerId: String!) {
  userCheckEarlyTrialCancel(input: {stripeCustomerId: $stripeCustomerId}) {
    earlyTrialCancel
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}
    `;

export const useUserCheckEarlyTrialCancelQuery = <
      TData = UserCheckEarlyTrialCancelQuery,
      TError = unknown
    >(
      variables: UserCheckEarlyTrialCancelQueryVariables,
      options?: Omit<UseQueryOptions<UserCheckEarlyTrialCancelQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserCheckEarlyTrialCancelQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserCheckEarlyTrialCancelQuery, TError, TData>(
      {
    queryKey: ['userCheckEarlyTrialCancel', variables],
    queryFn: fetcher<UserCheckEarlyTrialCancelQuery, UserCheckEarlyTrialCancelQueryVariables>(UserCheckEarlyTrialCancelDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserCheckEarlyTrialCancelQuery.document = UserCheckEarlyTrialCancelDocument;

useUserCheckEarlyTrialCancelQuery.getKey = (variables: UserCheckEarlyTrialCancelQueryVariables) => ['userCheckEarlyTrialCancel', variables];

useUserCheckEarlyTrialCancelQuery.rootKey = 'userCheckEarlyTrialCancel';

export const useSuspenseUserCheckEarlyTrialCancelQuery = <
      TData = UserCheckEarlyTrialCancelQuery,
      TError = unknown
    >(
      variables: UserCheckEarlyTrialCancelQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserCheckEarlyTrialCancelQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserCheckEarlyTrialCancelQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserCheckEarlyTrialCancelQuery, TError, TData>(
      {
    queryKey: ['userCheckEarlyTrialCancelSuspense', variables],
    queryFn: fetcher<UserCheckEarlyTrialCancelQuery, UserCheckEarlyTrialCancelQueryVariables>(UserCheckEarlyTrialCancelDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserCheckEarlyTrialCancelQuery.document = UserCheckEarlyTrialCancelDocument;

useSuspenseUserCheckEarlyTrialCancelQuery.getKey = (variables: UserCheckEarlyTrialCancelQueryVariables) => ['userCheckEarlyTrialCancelSuspense', variables];

useSuspenseUserCheckEarlyTrialCancelQuery.rootKey = 'userCheckEarlyTrialCancel';

export const useInfiniteUserCheckEarlyTrialCancelQuery = <
      TData = InfiniteData<UserCheckEarlyTrialCancelQuery>,
      TError = unknown
    >(
      variables: UserCheckEarlyTrialCancelQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserCheckEarlyTrialCancelQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserCheckEarlyTrialCancelQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserCheckEarlyTrialCancelQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['userCheckEarlyTrialCancel.infinite', variables],
      queryFn: (metaData) => fetcher<UserCheckEarlyTrialCancelQuery, UserCheckEarlyTrialCancelQueryVariables>(UserCheckEarlyTrialCancelDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserCheckEarlyTrialCancelQuery.getKey = (variables: UserCheckEarlyTrialCancelQueryVariables) => ['userCheckEarlyTrialCancel.infinite', variables];

useInfiniteUserCheckEarlyTrialCancelQuery.rootKey = 'userCheckEarlyTrialCancel.infinite';

export const useSuspenseInfiniteUserCheckEarlyTrialCancelQuery = <
      TData = InfiniteData<UserCheckEarlyTrialCancelQuery>,
      TError = unknown
    >(
      variables: UserCheckEarlyTrialCancelQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserCheckEarlyTrialCancelQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserCheckEarlyTrialCancelQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserCheckEarlyTrialCancelQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['userCheckEarlyTrialCancel.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserCheckEarlyTrialCancelQuery, UserCheckEarlyTrialCancelQueryVariables>(UserCheckEarlyTrialCancelDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserCheckEarlyTrialCancelQuery.getKey = (variables: UserCheckEarlyTrialCancelQueryVariables) => ['userCheckEarlyTrialCancel.infiniteSuspense', variables];

useSuspenseInfiniteUserCheckEarlyTrialCancelQuery.rootKey = 'userCheckEarlyTrialCancel.infinite';


useUserCheckEarlyTrialCancelQuery.fetcher = (variables: UserCheckEarlyTrialCancelQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserCheckEarlyTrialCancelQuery, UserCheckEarlyTrialCancelQueryVariables>(UserCheckEarlyTrialCancelDocument, variables, options, fetchOptions);

export const UserEligibleToAutostartFreeTrialDocument = /*#__PURE__*/ `
    query userEligibleToAutostartFreeTrial {
  me {
    user {
      subscriptionAccess {
        allAccess {
          isEligibleForAutoStartTrial
        }
        studioAi {
          isEligibleForAutoStartTrial
        }
      }
      stripeCustomerId
      stripeCustomer {
        account
        id
      }
      id
      currency {
        code
      }
    }
    errors {
      code
      message
    }
  }
}
    `;

export const useUserEligibleToAutostartFreeTrialQuery = <
      TData = UserEligibleToAutostartFreeTrialQuery,
      TError = unknown
    >(
      variables?: UserEligibleToAutostartFreeTrialQueryVariables,
      options?: Omit<UseQueryOptions<UserEligibleToAutostartFreeTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserEligibleToAutostartFreeTrialQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserEligibleToAutostartFreeTrialQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userEligibleToAutostartFreeTrial'] : ['userEligibleToAutostartFreeTrial', variables],
    queryFn: fetcher<UserEligibleToAutostartFreeTrialQuery, UserEligibleToAutostartFreeTrialQueryVariables>(UserEligibleToAutostartFreeTrialDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserEligibleToAutostartFreeTrialQuery.document = UserEligibleToAutostartFreeTrialDocument;

useUserEligibleToAutostartFreeTrialQuery.getKey = (variables?: UserEligibleToAutostartFreeTrialQueryVariables) => variables === undefined ? ['userEligibleToAutostartFreeTrial'] : ['userEligibleToAutostartFreeTrial', variables];

useUserEligibleToAutostartFreeTrialQuery.rootKey = 'userEligibleToAutostartFreeTrial';

export const useSuspenseUserEligibleToAutostartFreeTrialQuery = <
      TData = UserEligibleToAutostartFreeTrialQuery,
      TError = unknown
    >(
      variables?: UserEligibleToAutostartFreeTrialQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserEligibleToAutostartFreeTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserEligibleToAutostartFreeTrialQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserEligibleToAutostartFreeTrialQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userEligibleToAutostartFreeTrialSuspense'] : ['userEligibleToAutostartFreeTrialSuspense', variables],
    queryFn: fetcher<UserEligibleToAutostartFreeTrialQuery, UserEligibleToAutostartFreeTrialQueryVariables>(UserEligibleToAutostartFreeTrialDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserEligibleToAutostartFreeTrialQuery.document = UserEligibleToAutostartFreeTrialDocument;

useSuspenseUserEligibleToAutostartFreeTrialQuery.getKey = (variables?: UserEligibleToAutostartFreeTrialQueryVariables) => variables === undefined ? ['userEligibleToAutostartFreeTrialSuspense'] : ['userEligibleToAutostartFreeTrialSuspense', variables];

useSuspenseUserEligibleToAutostartFreeTrialQuery.rootKey = 'userEligibleToAutostartFreeTrial';

export const useInfiniteUserEligibleToAutostartFreeTrialQuery = <
      TData = InfiniteData<UserEligibleToAutostartFreeTrialQuery>,
      TError = unknown
    >(
      variables: UserEligibleToAutostartFreeTrialQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserEligibleToAutostartFreeTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserEligibleToAutostartFreeTrialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserEligibleToAutostartFreeTrialQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userEligibleToAutostartFreeTrial.infinite'] : ['userEligibleToAutostartFreeTrial.infinite', variables],
      queryFn: (metaData) => fetcher<UserEligibleToAutostartFreeTrialQuery, UserEligibleToAutostartFreeTrialQueryVariables>(UserEligibleToAutostartFreeTrialDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserEligibleToAutostartFreeTrialQuery.getKey = (variables?: UserEligibleToAutostartFreeTrialQueryVariables) => variables === undefined ? ['userEligibleToAutostartFreeTrial.infinite'] : ['userEligibleToAutostartFreeTrial.infinite', variables];

useInfiniteUserEligibleToAutostartFreeTrialQuery.rootKey = 'userEligibleToAutostartFreeTrial.infinite';

export const useSuspenseInfiniteUserEligibleToAutostartFreeTrialQuery = <
      TData = InfiniteData<UserEligibleToAutostartFreeTrialQuery>,
      TError = unknown
    >(
      variables: UserEligibleToAutostartFreeTrialQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserEligibleToAutostartFreeTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserEligibleToAutostartFreeTrialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserEligibleToAutostartFreeTrialQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userEligibleToAutostartFreeTrial.infiniteSuspense'] : ['userEligibleToAutostartFreeTrial.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserEligibleToAutostartFreeTrialQuery, UserEligibleToAutostartFreeTrialQueryVariables>(UserEligibleToAutostartFreeTrialDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserEligibleToAutostartFreeTrialQuery.getKey = (variables?: UserEligibleToAutostartFreeTrialQueryVariables) => variables === undefined ? ['userEligibleToAutostartFreeTrial.infiniteSuspense'] : ['userEligibleToAutostartFreeTrial.infiniteSuspense', variables];

useSuspenseInfiniteUserEligibleToAutostartFreeTrialQuery.rootKey = 'userEligibleToAutostartFreeTrial.infinite';


useUserEligibleToAutostartFreeTrialQuery.fetcher = (variables?: UserEligibleToAutostartFreeTrialQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserEligibleToAutostartFreeTrialQuery, UserEligibleToAutostartFreeTrialQueryVariables>(UserEligibleToAutostartFreeTrialDocument, variables, options, fetchOptions);

export const UserShippingAddressDocument = /*#__PURE__*/ `
    query userShippingAddress {
  usersShippingAddress {
    address {
      name
      address1
      address2
      city
      state
      postCode
      country
    }
    message
  }
}
    `;

export const useUserShippingAddressQuery = <
      TData = UserShippingAddressQuery,
      TError = unknown
    >(
      variables?: UserShippingAddressQueryVariables,
      options?: Omit<UseQueryOptions<UserShippingAddressQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserShippingAddressQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserShippingAddressQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userShippingAddress'] : ['userShippingAddress', variables],
    queryFn: fetcher<UserShippingAddressQuery, UserShippingAddressQueryVariables>(UserShippingAddressDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserShippingAddressQuery.document = UserShippingAddressDocument;

useUserShippingAddressQuery.getKey = (variables?: UserShippingAddressQueryVariables) => variables === undefined ? ['userShippingAddress'] : ['userShippingAddress', variables];

useUserShippingAddressQuery.rootKey = 'userShippingAddress';

export const useSuspenseUserShippingAddressQuery = <
      TData = UserShippingAddressQuery,
      TError = unknown
    >(
      variables?: UserShippingAddressQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserShippingAddressQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserShippingAddressQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserShippingAddressQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userShippingAddressSuspense'] : ['userShippingAddressSuspense', variables],
    queryFn: fetcher<UserShippingAddressQuery, UserShippingAddressQueryVariables>(UserShippingAddressDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserShippingAddressQuery.document = UserShippingAddressDocument;

useSuspenseUserShippingAddressQuery.getKey = (variables?: UserShippingAddressQueryVariables) => variables === undefined ? ['userShippingAddressSuspense'] : ['userShippingAddressSuspense', variables];

useSuspenseUserShippingAddressQuery.rootKey = 'userShippingAddress';

export const useInfiniteUserShippingAddressQuery = <
      TData = InfiniteData<UserShippingAddressQuery>,
      TError = unknown
    >(
      variables: UserShippingAddressQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserShippingAddressQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserShippingAddressQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserShippingAddressQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userShippingAddress.infinite'] : ['userShippingAddress.infinite', variables],
      queryFn: (metaData) => fetcher<UserShippingAddressQuery, UserShippingAddressQueryVariables>(UserShippingAddressDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserShippingAddressQuery.getKey = (variables?: UserShippingAddressQueryVariables) => variables === undefined ? ['userShippingAddress.infinite'] : ['userShippingAddress.infinite', variables];

useInfiniteUserShippingAddressQuery.rootKey = 'userShippingAddress.infinite';

export const useSuspenseInfiniteUserShippingAddressQuery = <
      TData = InfiniteData<UserShippingAddressQuery>,
      TError = unknown
    >(
      variables: UserShippingAddressQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserShippingAddressQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserShippingAddressQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserShippingAddressQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userShippingAddress.infiniteSuspense'] : ['userShippingAddress.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserShippingAddressQuery, UserShippingAddressQueryVariables>(UserShippingAddressDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserShippingAddressQuery.getKey = (variables?: UserShippingAddressQueryVariables) => variables === undefined ? ['userShippingAddress.infiniteSuspense'] : ['userShippingAddress.infiniteSuspense', variables];

useSuspenseInfiniteUserShippingAddressQuery.rootKey = 'userShippingAddress.infinite';


useUserShippingAddressQuery.fetcher = (variables?: UserShippingAddressQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserShippingAddressQuery, UserShippingAddressQueryVariables>(UserShippingAddressDocument, variables, options, fetchOptions);

export const UserProjectDetailsDocument = /*#__PURE__*/ `
    query userProjectDetails {
  me {
    token
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

export const useUserProjectDetailsQuery = <
      TData = UserProjectDetailsQuery,
      TError = unknown
    >(
      variables?: UserProjectDetailsQueryVariables,
      options?: Omit<UseQueryOptions<UserProjectDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserProjectDetailsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserProjectDetailsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userProjectDetails'] : ['userProjectDetails', variables],
    queryFn: fetcher<UserProjectDetailsQuery, UserProjectDetailsQueryVariables>(UserProjectDetailsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserProjectDetailsQuery.document = UserProjectDetailsDocument;

useUserProjectDetailsQuery.getKey = (variables?: UserProjectDetailsQueryVariables) => variables === undefined ? ['userProjectDetails'] : ['userProjectDetails', variables];

useUserProjectDetailsQuery.rootKey = 'userProjectDetails';

export const useSuspenseUserProjectDetailsQuery = <
      TData = UserProjectDetailsQuery,
      TError = unknown
    >(
      variables?: UserProjectDetailsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserProjectDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserProjectDetailsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserProjectDetailsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userProjectDetailsSuspense'] : ['userProjectDetailsSuspense', variables],
    queryFn: fetcher<UserProjectDetailsQuery, UserProjectDetailsQueryVariables>(UserProjectDetailsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserProjectDetailsQuery.document = UserProjectDetailsDocument;

useSuspenseUserProjectDetailsQuery.getKey = (variables?: UserProjectDetailsQueryVariables) => variables === undefined ? ['userProjectDetailsSuspense'] : ['userProjectDetailsSuspense', variables];

useSuspenseUserProjectDetailsQuery.rootKey = 'userProjectDetails';

export const useInfiniteUserProjectDetailsQuery = <
      TData = InfiniteData<UserProjectDetailsQuery>,
      TError = unknown
    >(
      variables: UserProjectDetailsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserProjectDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserProjectDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserProjectDetailsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userProjectDetails.infinite'] : ['userProjectDetails.infinite', variables],
      queryFn: (metaData) => fetcher<UserProjectDetailsQuery, UserProjectDetailsQueryVariables>(UserProjectDetailsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserProjectDetailsQuery.getKey = (variables?: UserProjectDetailsQueryVariables) => variables === undefined ? ['userProjectDetails.infinite'] : ['userProjectDetails.infinite', variables];

useInfiniteUserProjectDetailsQuery.rootKey = 'userProjectDetails.infinite';

export const useSuspenseInfiniteUserProjectDetailsQuery = <
      TData = InfiniteData<UserProjectDetailsQuery>,
      TError = unknown
    >(
      variables: UserProjectDetailsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserProjectDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserProjectDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserProjectDetailsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userProjectDetails.infiniteSuspense'] : ['userProjectDetails.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserProjectDetailsQuery, UserProjectDetailsQueryVariables>(UserProjectDetailsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserProjectDetailsQuery.getKey = (variables?: UserProjectDetailsQueryVariables) => variables === undefined ? ['userProjectDetails.infiniteSuspense'] : ['userProjectDetails.infiniteSuspense', variables];

useSuspenseInfiniteUserProjectDetailsQuery.rootKey = 'userProjectDetails.infinite';


useUserProjectDetailsQuery.fetcher = (variables?: UserProjectDetailsQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserProjectDetailsQuery, UserProjectDetailsQueryVariables>(UserProjectDetailsDocument, variables, options, fetchOptions);

export const LogInDocument = /*#__PURE__*/ `
    mutation logIn($input: LoginInput!) {
  login(input: $input) {
    ...LoginResponseFields
    challenge {
      type
      otp
    }
    errors {
      code
      message
    }
  }
}
    ${LoginResponseFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

export const useLogInMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LogInMutation, TError, LogInMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<LogInMutation, TError, LogInMutationVariables, TContext>(
      {
    mutationKey: ['logIn'],
    mutationFn: (variables?: LogInMutationVariables) => fetcher<LogInMutation, LogInMutationVariables>(LogInDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useLogInMutation.getKey = () => ['logIn'];


useLogInMutation.fetcher = (variables: LogInMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<LogInMutation, LogInMutationVariables>(LogInDocument, variables, options, fetchOptions);

export const RegisterDocument = /*#__PURE__*/ `
    mutation register($input: RegisterInput!) {
  register(input: $input) {
    ...RegisterResponseFields
    challenge {
      type
      otp
    }
    errors {
      code
      message
    }
  }
}
    ${RegisterResponseFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

export const useRegisterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RegisterMutation, TError, RegisterMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<RegisterMutation, TError, RegisterMutationVariables, TContext>(
      {
    mutationKey: ['register'],
    mutationFn: (variables?: RegisterMutationVariables) => fetcher<RegisterMutation, RegisterMutationVariables>(RegisterDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useRegisterMutation.getKey = () => ['register'];


useRegisterMutation.fetcher = (variables: RegisterMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<RegisterMutation, RegisterMutationVariables>(RegisterDocument, variables, options, fetchOptions);

export const LostPasswordDocument = /*#__PURE__*/ `
    mutation lostPassword($input: LostPasswordInput!) {
  lostPassword(input: $input) {
    success
    errors {
      code
      message
    }
  }
}
    `;

export const useLostPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LostPasswordMutation, TError, LostPasswordMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<LostPasswordMutation, TError, LostPasswordMutationVariables, TContext>(
      {
    mutationKey: ['lostPassword'],
    mutationFn: (variables?: LostPasswordMutationVariables) => fetcher<LostPasswordMutation, LostPasswordMutationVariables>(LostPasswordDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useLostPasswordMutation.getKey = () => ['lostPassword'];


useLostPasswordMutation.fetcher = (variables: LostPasswordMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<LostPasswordMutation, LostPasswordMutationVariables>(LostPasswordDocument, variables, options, fetchOptions);

export const ReportJwtAuthOutcomeDocument = /*#__PURE__*/ `
    mutation reportJwtAuthOutcome($input: JwtAuthOutcomeInput!) {
  reportJwtAuthOutcome(input: $input) {
    accepted
  }
}
    `;

export const useReportJwtAuthOutcomeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReportJwtAuthOutcomeMutation, TError, ReportJwtAuthOutcomeMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<ReportJwtAuthOutcomeMutation, TError, ReportJwtAuthOutcomeMutationVariables, TContext>(
      {
    mutationKey: ['reportJwtAuthOutcome'],
    mutationFn: (variables?: ReportJwtAuthOutcomeMutationVariables) => fetcher<ReportJwtAuthOutcomeMutation, ReportJwtAuthOutcomeMutationVariables>(ReportJwtAuthOutcomeDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useReportJwtAuthOutcomeMutation.getKey = () => ['reportJwtAuthOutcome'];


useReportJwtAuthOutcomeMutation.fetcher = (variables: ReportJwtAuthOutcomeMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<ReportJwtAuthOutcomeMutation, ReportJwtAuthOutcomeMutationVariables>(ReportJwtAuthOutcomeDocument, variables, options, fetchOptions);

export const UserAuthDocument = /*#__PURE__*/ `
    query userAuth {
  me {
    token
    user {
      id
      isTemporary
    }
  }
}
    `;

export const useUserAuthQuery = <
      TData = UserAuthQuery,
      TError = unknown
    >(
      variables?: UserAuthQueryVariables,
      options?: Omit<UseQueryOptions<UserAuthQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserAuthQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserAuthQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userAuth'] : ['userAuth', variables],
    queryFn: fetcher<UserAuthQuery, UserAuthQueryVariables>(UserAuthDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserAuthQuery.document = UserAuthDocument;

useUserAuthQuery.getKey = (variables?: UserAuthQueryVariables) => variables === undefined ? ['userAuth'] : ['userAuth', variables];

useUserAuthQuery.rootKey = 'userAuth';

export const useSuspenseUserAuthQuery = <
      TData = UserAuthQuery,
      TError = unknown
    >(
      variables?: UserAuthQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserAuthQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserAuthQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserAuthQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userAuthSuspense'] : ['userAuthSuspense', variables],
    queryFn: fetcher<UserAuthQuery, UserAuthQueryVariables>(UserAuthDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserAuthQuery.document = UserAuthDocument;

useSuspenseUserAuthQuery.getKey = (variables?: UserAuthQueryVariables) => variables === undefined ? ['userAuthSuspense'] : ['userAuthSuspense', variables];

useSuspenseUserAuthQuery.rootKey = 'userAuth';

export const useInfiniteUserAuthQuery = <
      TData = InfiniteData<UserAuthQuery>,
      TError = unknown
    >(
      variables: UserAuthQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserAuthQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserAuthQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserAuthQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userAuth.infinite'] : ['userAuth.infinite', variables],
      queryFn: (metaData) => fetcher<UserAuthQuery, UserAuthQueryVariables>(UserAuthDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserAuthQuery.getKey = (variables?: UserAuthQueryVariables) => variables === undefined ? ['userAuth.infinite'] : ['userAuth.infinite', variables];

useInfiniteUserAuthQuery.rootKey = 'userAuth.infinite';

export const useSuspenseInfiniteUserAuthQuery = <
      TData = InfiniteData<UserAuthQuery>,
      TError = unknown
    >(
      variables: UserAuthQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserAuthQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserAuthQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserAuthQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userAuth.infiniteSuspense'] : ['userAuth.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserAuthQuery, UserAuthQueryVariables>(UserAuthDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserAuthQuery.getKey = (variables?: UserAuthQueryVariables) => variables === undefined ? ['userAuth.infiniteSuspense'] : ['userAuth.infiniteSuspense', variables];

useSuspenseInfiniteUserAuthQuery.rootKey = 'userAuth.infinite';


useUserAuthQuery.fetcher = (variables?: UserAuthQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserAuthQuery, UserAuthQueryVariables>(UserAuthDocument, variables, options, fetchOptions);

export const UserSubscriptionsGraphicsDocument = /*#__PURE__*/ `
    query userSubscriptionsGraphics {
  me {
    user {
      subscriptions {
        graphics
      }
    }
  }
}
    `;

export const useUserSubscriptionsGraphicsQuery = <
      TData = UserSubscriptionsGraphicsQuery,
      TError = unknown
    >(
      variables?: UserSubscriptionsGraphicsQueryVariables,
      options?: Omit<UseQueryOptions<UserSubscriptionsGraphicsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserSubscriptionsGraphicsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserSubscriptionsGraphicsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userSubscriptionsGraphics'] : ['userSubscriptionsGraphics', variables],
    queryFn: fetcher<UserSubscriptionsGraphicsQuery, UserSubscriptionsGraphicsQueryVariables>(UserSubscriptionsGraphicsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserSubscriptionsGraphicsQuery.document = UserSubscriptionsGraphicsDocument;

useUserSubscriptionsGraphicsQuery.getKey = (variables?: UserSubscriptionsGraphicsQueryVariables) => variables === undefined ? ['userSubscriptionsGraphics'] : ['userSubscriptionsGraphics', variables];

useUserSubscriptionsGraphicsQuery.rootKey = 'userSubscriptionsGraphics';

export const useSuspenseUserSubscriptionsGraphicsQuery = <
      TData = UserSubscriptionsGraphicsQuery,
      TError = unknown
    >(
      variables?: UserSubscriptionsGraphicsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserSubscriptionsGraphicsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserSubscriptionsGraphicsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserSubscriptionsGraphicsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userSubscriptionsGraphicsSuspense'] : ['userSubscriptionsGraphicsSuspense', variables],
    queryFn: fetcher<UserSubscriptionsGraphicsQuery, UserSubscriptionsGraphicsQueryVariables>(UserSubscriptionsGraphicsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserSubscriptionsGraphicsQuery.document = UserSubscriptionsGraphicsDocument;

useSuspenseUserSubscriptionsGraphicsQuery.getKey = (variables?: UserSubscriptionsGraphicsQueryVariables) => variables === undefined ? ['userSubscriptionsGraphicsSuspense'] : ['userSubscriptionsGraphicsSuspense', variables];

useSuspenseUserSubscriptionsGraphicsQuery.rootKey = 'userSubscriptionsGraphics';

export const useInfiniteUserSubscriptionsGraphicsQuery = <
      TData = InfiniteData<UserSubscriptionsGraphicsQuery>,
      TError = unknown
    >(
      variables: UserSubscriptionsGraphicsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserSubscriptionsGraphicsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserSubscriptionsGraphicsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserSubscriptionsGraphicsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userSubscriptionsGraphics.infinite'] : ['userSubscriptionsGraphics.infinite', variables],
      queryFn: (metaData) => fetcher<UserSubscriptionsGraphicsQuery, UserSubscriptionsGraphicsQueryVariables>(UserSubscriptionsGraphicsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserSubscriptionsGraphicsQuery.getKey = (variables?: UserSubscriptionsGraphicsQueryVariables) => variables === undefined ? ['userSubscriptionsGraphics.infinite'] : ['userSubscriptionsGraphics.infinite', variables];

useInfiniteUserSubscriptionsGraphicsQuery.rootKey = 'userSubscriptionsGraphics.infinite';

export const useSuspenseInfiniteUserSubscriptionsGraphicsQuery = <
      TData = InfiniteData<UserSubscriptionsGraphicsQuery>,
      TError = unknown
    >(
      variables: UserSubscriptionsGraphicsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserSubscriptionsGraphicsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserSubscriptionsGraphicsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserSubscriptionsGraphicsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userSubscriptionsGraphics.infiniteSuspense'] : ['userSubscriptionsGraphics.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserSubscriptionsGraphicsQuery, UserSubscriptionsGraphicsQueryVariables>(UserSubscriptionsGraphicsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserSubscriptionsGraphicsQuery.getKey = (variables?: UserSubscriptionsGraphicsQueryVariables) => variables === undefined ? ['userSubscriptionsGraphics.infiniteSuspense'] : ['userSubscriptionsGraphics.infiniteSuspense', variables];

useSuspenseInfiniteUserSubscriptionsGraphicsQuery.rootKey = 'userSubscriptionsGraphics.infinite';


useUserSubscriptionsGraphicsQuery.fetcher = (variables?: UserSubscriptionsGraphicsQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserSubscriptionsGraphicsQuery, UserSubscriptionsGraphicsQueryVariables>(UserSubscriptionsGraphicsDocument, variables, options, fetchOptions);

export const UserAllSubscriptionsTypesDocument = /*#__PURE__*/ `
    query userAllSubscriptionsTypes {
  me {
    user {
      subscriptions {
        fonts
        crafts
        graphics
        embroidery
        classes
      }
    }
  }
}
    `;

export const useUserAllSubscriptionsTypesQuery = <
      TData = UserAllSubscriptionsTypesQuery,
      TError = unknown
    >(
      variables?: UserAllSubscriptionsTypesQueryVariables,
      options?: Omit<UseQueryOptions<UserAllSubscriptionsTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserAllSubscriptionsTypesQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserAllSubscriptionsTypesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userAllSubscriptionsTypes'] : ['userAllSubscriptionsTypes', variables],
    queryFn: fetcher<UserAllSubscriptionsTypesQuery, UserAllSubscriptionsTypesQueryVariables>(UserAllSubscriptionsTypesDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserAllSubscriptionsTypesQuery.document = UserAllSubscriptionsTypesDocument;

useUserAllSubscriptionsTypesQuery.getKey = (variables?: UserAllSubscriptionsTypesQueryVariables) => variables === undefined ? ['userAllSubscriptionsTypes'] : ['userAllSubscriptionsTypes', variables];

useUserAllSubscriptionsTypesQuery.rootKey = 'userAllSubscriptionsTypes';

export const useSuspenseUserAllSubscriptionsTypesQuery = <
      TData = UserAllSubscriptionsTypesQuery,
      TError = unknown
    >(
      variables?: UserAllSubscriptionsTypesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserAllSubscriptionsTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserAllSubscriptionsTypesQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserAllSubscriptionsTypesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userAllSubscriptionsTypesSuspense'] : ['userAllSubscriptionsTypesSuspense', variables],
    queryFn: fetcher<UserAllSubscriptionsTypesQuery, UserAllSubscriptionsTypesQueryVariables>(UserAllSubscriptionsTypesDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserAllSubscriptionsTypesQuery.document = UserAllSubscriptionsTypesDocument;

useSuspenseUserAllSubscriptionsTypesQuery.getKey = (variables?: UserAllSubscriptionsTypesQueryVariables) => variables === undefined ? ['userAllSubscriptionsTypesSuspense'] : ['userAllSubscriptionsTypesSuspense', variables];

useSuspenseUserAllSubscriptionsTypesQuery.rootKey = 'userAllSubscriptionsTypes';

export const useInfiniteUserAllSubscriptionsTypesQuery = <
      TData = InfiniteData<UserAllSubscriptionsTypesQuery>,
      TError = unknown
    >(
      variables: UserAllSubscriptionsTypesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserAllSubscriptionsTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserAllSubscriptionsTypesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserAllSubscriptionsTypesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userAllSubscriptionsTypes.infinite'] : ['userAllSubscriptionsTypes.infinite', variables],
      queryFn: (metaData) => fetcher<UserAllSubscriptionsTypesQuery, UserAllSubscriptionsTypesQueryVariables>(UserAllSubscriptionsTypesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserAllSubscriptionsTypesQuery.getKey = (variables?: UserAllSubscriptionsTypesQueryVariables) => variables === undefined ? ['userAllSubscriptionsTypes.infinite'] : ['userAllSubscriptionsTypes.infinite', variables];

useInfiniteUserAllSubscriptionsTypesQuery.rootKey = 'userAllSubscriptionsTypes.infinite';

export const useSuspenseInfiniteUserAllSubscriptionsTypesQuery = <
      TData = InfiniteData<UserAllSubscriptionsTypesQuery>,
      TError = unknown
    >(
      variables: UserAllSubscriptionsTypesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserAllSubscriptionsTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserAllSubscriptionsTypesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserAllSubscriptionsTypesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userAllSubscriptionsTypes.infiniteSuspense'] : ['userAllSubscriptionsTypes.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserAllSubscriptionsTypesQuery, UserAllSubscriptionsTypesQueryVariables>(UserAllSubscriptionsTypesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserAllSubscriptionsTypesQuery.getKey = (variables?: UserAllSubscriptionsTypesQueryVariables) => variables === undefined ? ['userAllSubscriptionsTypes.infiniteSuspense'] : ['userAllSubscriptionsTypes.infiniteSuspense', variables];

useSuspenseInfiniteUserAllSubscriptionsTypesQuery.rootKey = 'userAllSubscriptionsTypes.infinite';


useUserAllSubscriptionsTypesQuery.fetcher = (variables?: UserAllSubscriptionsTypesQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserAllSubscriptionsTypesQuery, UserAllSubscriptionsTypesQueryVariables>(UserAllSubscriptionsTypesDocument, variables, options, fetchOptions);

export const UserCurrencyCodeDocument = /*#__PURE__*/ `
    query userCurrencyCode {
  me {
    user {
      currency {
        code
      }
    }
    currency {
      code
    }
  }
}
    `;

export const useUserCurrencyCodeQuery = <
      TData = UserCurrencyCodeQuery,
      TError = unknown
    >(
      variables?: UserCurrencyCodeQueryVariables,
      options?: Omit<UseQueryOptions<UserCurrencyCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserCurrencyCodeQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserCurrencyCodeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userCurrencyCode'] : ['userCurrencyCode', variables],
    queryFn: fetcher<UserCurrencyCodeQuery, UserCurrencyCodeQueryVariables>(UserCurrencyCodeDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserCurrencyCodeQuery.document = UserCurrencyCodeDocument;

useUserCurrencyCodeQuery.getKey = (variables?: UserCurrencyCodeQueryVariables) => variables === undefined ? ['userCurrencyCode'] : ['userCurrencyCode', variables];

useUserCurrencyCodeQuery.rootKey = 'userCurrencyCode';

export const useSuspenseUserCurrencyCodeQuery = <
      TData = UserCurrencyCodeQuery,
      TError = unknown
    >(
      variables?: UserCurrencyCodeQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserCurrencyCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserCurrencyCodeQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserCurrencyCodeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userCurrencyCodeSuspense'] : ['userCurrencyCodeSuspense', variables],
    queryFn: fetcher<UserCurrencyCodeQuery, UserCurrencyCodeQueryVariables>(UserCurrencyCodeDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserCurrencyCodeQuery.document = UserCurrencyCodeDocument;

useSuspenseUserCurrencyCodeQuery.getKey = (variables?: UserCurrencyCodeQueryVariables) => variables === undefined ? ['userCurrencyCodeSuspense'] : ['userCurrencyCodeSuspense', variables];

useSuspenseUserCurrencyCodeQuery.rootKey = 'userCurrencyCode';

export const useInfiniteUserCurrencyCodeQuery = <
      TData = InfiniteData<UserCurrencyCodeQuery>,
      TError = unknown
    >(
      variables: UserCurrencyCodeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserCurrencyCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserCurrencyCodeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserCurrencyCodeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userCurrencyCode.infinite'] : ['userCurrencyCode.infinite', variables],
      queryFn: (metaData) => fetcher<UserCurrencyCodeQuery, UserCurrencyCodeQueryVariables>(UserCurrencyCodeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserCurrencyCodeQuery.getKey = (variables?: UserCurrencyCodeQueryVariables) => variables === undefined ? ['userCurrencyCode.infinite'] : ['userCurrencyCode.infinite', variables];

useInfiniteUserCurrencyCodeQuery.rootKey = 'userCurrencyCode.infinite';

export const useSuspenseInfiniteUserCurrencyCodeQuery = <
      TData = InfiniteData<UserCurrencyCodeQuery>,
      TError = unknown
    >(
      variables: UserCurrencyCodeQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserCurrencyCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserCurrencyCodeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserCurrencyCodeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userCurrencyCode.infiniteSuspense'] : ['userCurrencyCode.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserCurrencyCodeQuery, UserCurrencyCodeQueryVariables>(UserCurrencyCodeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserCurrencyCodeQuery.getKey = (variables?: UserCurrencyCodeQueryVariables) => variables === undefined ? ['userCurrencyCode.infiniteSuspense'] : ['userCurrencyCode.infiniteSuspense', variables];

useSuspenseInfiniteUserCurrencyCodeQuery.rootKey = 'userCurrencyCode.infinite';


useUserCurrencyCodeQuery.fetcher = (variables?: UserCurrencyCodeQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserCurrencyCodeQuery, UserCurrencyCodeQueryVariables>(UserCurrencyCodeDocument, variables, options, fetchOptions);

export const UsersUpdateFlagsDocument = /*#__PURE__*/ `
    mutation usersUpdateFlags($input: UserUpdateFlagsInput!) {
  usersUpdateFlags(input: $input) {
    success
    errors {
      code
      message
    }
  }
}
    `;

export const useUsersUpdateFlagsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UsersUpdateFlagsMutation, TError, UsersUpdateFlagsMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<UsersUpdateFlagsMutation, TError, UsersUpdateFlagsMutationVariables, TContext>(
      {
    mutationKey: ['usersUpdateFlags'],
    mutationFn: (variables?: UsersUpdateFlagsMutationVariables) => fetcher<UsersUpdateFlagsMutation, UsersUpdateFlagsMutationVariables>(UsersUpdateFlagsDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useUsersUpdateFlagsMutation.getKey = () => ['usersUpdateFlags'];


useUsersUpdateFlagsMutation.fetcher = (variables: UsersUpdateFlagsMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UsersUpdateFlagsMutation, UsersUpdateFlagsMutationVariables>(UsersUpdateFlagsDocument, variables, options, fetchOptions);

export const PublicUserProfileDocument = /*#__PURE__*/ `
    query publicUserProfile($slug: String!) {
  publicUserProfile(slug: $slug) {
    id
    avatarUrl
    firstName
    lastName
    slug
    displayName
    shopName
    avatarUrl
    profileUrls {
      crafter
      designer
      teacher
      theArtistry
    }
    isCreativeFabrica
    isVerified
    isPremium
    isFollowed
    location {
      country
    }
    following
    isTemporary
    superSkill
  }
}
    `;

export const usePublicUserProfileQuery = <
      TData = PublicUserProfileQuery,
      TError = unknown
    >(
      variables: PublicUserProfileQueryVariables,
      options?: Omit<UseQueryOptions<PublicUserProfileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PublicUserProfileQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<PublicUserProfileQuery, TError, TData>(
      {
    queryKey: ['publicUserProfile', variables],
    queryFn: fetcher<PublicUserProfileQuery, PublicUserProfileQueryVariables>(PublicUserProfileDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

usePublicUserProfileQuery.document = PublicUserProfileDocument;

usePublicUserProfileQuery.getKey = (variables: PublicUserProfileQueryVariables) => ['publicUserProfile', variables];

usePublicUserProfileQuery.rootKey = 'publicUserProfile';

export const useSuspensePublicUserProfileQuery = <
      TData = PublicUserProfileQuery,
      TError = unknown
    >(
      variables: PublicUserProfileQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PublicUserProfileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PublicUserProfileQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<PublicUserProfileQuery, TError, TData>(
      {
    queryKey: ['publicUserProfileSuspense', variables],
    queryFn: fetcher<PublicUserProfileQuery, PublicUserProfileQueryVariables>(PublicUserProfileDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspensePublicUserProfileQuery.document = PublicUserProfileDocument;

useSuspensePublicUserProfileQuery.getKey = (variables: PublicUserProfileQueryVariables) => ['publicUserProfileSuspense', variables];

useSuspensePublicUserProfileQuery.rootKey = 'publicUserProfile';

export const useInfinitePublicUserProfileQuery = <
      TData = InfiniteData<PublicUserProfileQuery>,
      TError = unknown
    >(
      variables: PublicUserProfileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PublicUserProfileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PublicUserProfileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PublicUserProfileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['publicUserProfile.infinite', variables],
      queryFn: (metaData) => fetcher<PublicUserProfileQuery, PublicUserProfileQueryVariables>(PublicUserProfileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePublicUserProfileQuery.getKey = (variables: PublicUserProfileQueryVariables) => ['publicUserProfile.infinite', variables];

useInfinitePublicUserProfileQuery.rootKey = 'publicUserProfile.infinite';

export const useSuspenseInfinitePublicUserProfileQuery = <
      TData = InfiniteData<PublicUserProfileQuery>,
      TError = unknown
    >(
      variables: PublicUserProfileQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<PublicUserProfileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<PublicUserProfileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<PublicUserProfileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['publicUserProfile.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<PublicUserProfileQuery, PublicUserProfileQueryVariables>(PublicUserProfileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfinitePublicUserProfileQuery.getKey = (variables: PublicUserProfileQueryVariables) => ['publicUserProfile.infiniteSuspense', variables];

useSuspenseInfinitePublicUserProfileQuery.rootKey = 'publicUserProfile.infinite';


usePublicUserProfileQuery.fetcher = (variables: PublicUserProfileQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<PublicUserProfileQuery, PublicUserProfileQueryVariables>(PublicUserProfileDocument, variables, options, fetchOptions);

export const UserFollowersCountDocument = /*#__PURE__*/ `
    query userFollowersCount($input: UserFollowersCountInput!) {
  userFollowersCount(input: $input) {
    FollowersCount
    FollowingCount
    errors {
      code
      message
    }
  }
}
    `;

export const useUserFollowersCountQuery = <
      TData = UserFollowersCountQuery,
      TError = unknown
    >(
      variables: UserFollowersCountQueryVariables,
      options?: Omit<UseQueryOptions<UserFollowersCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserFollowersCountQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserFollowersCountQuery, TError, TData>(
      {
    queryKey: ['userFollowersCount', variables],
    queryFn: fetcher<UserFollowersCountQuery, UserFollowersCountQueryVariables>(UserFollowersCountDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserFollowersCountQuery.document = UserFollowersCountDocument;

useUserFollowersCountQuery.getKey = (variables: UserFollowersCountQueryVariables) => ['userFollowersCount', variables];

useUserFollowersCountQuery.rootKey = 'userFollowersCount';

export const useSuspenseUserFollowersCountQuery = <
      TData = UserFollowersCountQuery,
      TError = unknown
    >(
      variables: UserFollowersCountQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserFollowersCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserFollowersCountQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserFollowersCountQuery, TError, TData>(
      {
    queryKey: ['userFollowersCountSuspense', variables],
    queryFn: fetcher<UserFollowersCountQuery, UserFollowersCountQueryVariables>(UserFollowersCountDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserFollowersCountQuery.document = UserFollowersCountDocument;

useSuspenseUserFollowersCountQuery.getKey = (variables: UserFollowersCountQueryVariables) => ['userFollowersCountSuspense', variables];

useSuspenseUserFollowersCountQuery.rootKey = 'userFollowersCount';

export const useInfiniteUserFollowersCountQuery = <
      TData = InfiniteData<UserFollowersCountQuery>,
      TError = unknown
    >(
      variables: UserFollowersCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserFollowersCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserFollowersCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserFollowersCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['userFollowersCount.infinite', variables],
      queryFn: (metaData) => fetcher<UserFollowersCountQuery, UserFollowersCountQueryVariables>(UserFollowersCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserFollowersCountQuery.getKey = (variables: UserFollowersCountQueryVariables) => ['userFollowersCount.infinite', variables];

useInfiniteUserFollowersCountQuery.rootKey = 'userFollowersCount.infinite';

export const useSuspenseInfiniteUserFollowersCountQuery = <
      TData = InfiniteData<UserFollowersCountQuery>,
      TError = unknown
    >(
      variables: UserFollowersCountQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserFollowersCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserFollowersCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserFollowersCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['userFollowersCount.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserFollowersCountQuery, UserFollowersCountQueryVariables>(UserFollowersCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserFollowersCountQuery.getKey = (variables: UserFollowersCountQueryVariables) => ['userFollowersCount.infiniteSuspense', variables];

useSuspenseInfiniteUserFollowersCountQuery.rootKey = 'userFollowersCount.infinite';


useUserFollowersCountQuery.fetcher = (variables: UserFollowersCountQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserFollowersCountQuery, UserFollowersCountQueryVariables>(UserFollowersCountDocument, variables, options, fetchOptions);

export const DeleteUserAccountDocument = /*#__PURE__*/ `
    mutation deleteUserAccount {
  deleteUserAccount {
    error {
      type
      description
    }
    deleted
  }
}
    `;

export const useDeleteUserAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUserAccountMutation, TError, DeleteUserAccountMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<DeleteUserAccountMutation, TError, DeleteUserAccountMutationVariables, TContext>(
      {
    mutationKey: ['deleteUserAccount'],
    mutationFn: (variables?: DeleteUserAccountMutationVariables) => fetcher<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>(DeleteUserAccountDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useDeleteUserAccountMutation.getKey = () => ['deleteUserAccount'];


useDeleteUserAccountMutation.fetcher = (variables?: DeleteUserAccountMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>(DeleteUserAccountDocument, variables, options, fetchOptions);

export const LogoutDocument = /*#__PURE__*/ `
    mutation logout {
  logout {
    logout {
      success
      message
    }
    errors {
      code
      message
    }
  }
}
    `;

export const useLogoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LogoutMutation, TError, LogoutMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<LogoutMutation, TError, LogoutMutationVariables, TContext>(
      {
    mutationKey: ['logout'],
    mutationFn: (variables?: LogoutMutationVariables) => fetcher<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useLogoutMutation.getKey = () => ['logout'];


useLogoutMutation.fetcher = (variables?: LogoutMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables, options, fetchOptions);
